import { render, staticRenderFns } from "./MedicinesTypes.vue?vue&type=template&id=ef2e0046&"
import script from "./MedicinesTypes.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports